import { render, staticRenderFns } from "./soilScreen.vue?vue&type=template&id=44d9eb5e&scoped=true&"
import script from "./soilScreen.vue?vue&type=script&lang=js&"
export * from "./soilScreen.vue?vue&type=script&lang=js&"
import style0 from "./soilScreen.vue?vue&type=style&index=0&id=44d9eb5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d9eb5e",
  null
  
)

export default component.exports